import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingDetailsComponent } from 'src/app/building-managment/building-details/building-details.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DetailsSectionComponent } from './details-section/details-section.component';
import { ActivitySectionComponent } from './activity-section/activity-section.component';
import { FloorManagementModule } from 'src/app/floor-management/floor-management.module';
import { ActivityModule } from 'src/app/shared-layout/Components/activity/activity.module';
import { BuildingFilterActvityModule } from 'src/app/shared-layout/Components/activity/building-filter-actvity/building-filter-actvity.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [
    BuildingDetailsComponent,
    DetailsSectionComponent,
    ActivitySectionComponent,
  ],
  imports: [
    CommonModule,
    SharedLayoutModule,
    WithTooltipModule,
    FloorManagementModule,
    MatButtonToggleModule,
    ActivityModule,
    BuildingFilterActvityModule,
    TranslateModule,
  ],
  exports: [BuildingDetailsComponent],
  providers: [LocalizationService, TranslateModule],
})
export class BuildingDetailsModule {}
